/* import __COLOCATED_TEMPLATE__ from './popover.hbs'; */
import { offset } from '@floating-ui/dom';
import Component from '@glimmer/component';
import styles from './popover.module.scss';

export default class SharedDropdownPopover extends Component {
  middleware = [offset(-6)];
  styles = styles;
}
